export const isPathnameOrNested = (pathname: string, basePathname: string) =>
  pathname === basePathname || pathname.startsWith(`${basePathname}/`);
